import { api, imgUrl } from "@/lib/api";

let info = null;
const listeners = new Set();

export const loadPlatformInfo = () => (info ||= api.get("/platform-info").then((r) => r.data).catch(() => { info = null; return {}; }));
export const onBrand = (fn) => { listeners.add(fn); return () => listeners.delete(fn); };

export function setFavicon(url) {
  let link = document.querySelector("link[rel='icon']");
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }
  link.href = url || "/api/platform/logo";
}

export function initBrand() {
  loadPlatformInfo().then((d) => { if (d.logo_url) setFavicon(imgUrl(d.logo_url)); });
}

export function refreshBrand() {
  info = null;
  return loadPlatformInfo().then((d) => {
    setFavicon(imgUrl(d.logo_url));
    listeners.forEach((fn) => fn(d.logo_url || ""));
  });
}
